<!-- 填空题 -->
<template>
  <div :class="{'compact-mode': isCompactMode}">
    <div>
      <el-card class="box-card">
        <div slot="header" class="subjectTitle" :style="getMarginStyles">
          <div class="subjectName">
            <span class="question-number" v-if="subjectId !=null">{{ subjectId }}.</span>
            <div class="editor-content-view question-title-content">
              <div v-html="processedTitle"></div>
            </div>
          </div>
        </div>
        <div class="blank-content-area">
          <!-- 填空题输入区域 -->
          <div class="blank-inputs" v-if="!haveAnswer">
            <div class="blank-input-group">
              <!-- <span class="blank-label">请填写答案：</span> -->
              <div class="inputs-container">
                <el-input
                  v-for="(blank, index) in blankInputs"
                  :key="index"
                  v-model="blankInputs[index]"
                  :placeholder="blankInputs.length > 1 ? '第' + (index + 1) + '空' : ''"
                  :disabled="isDis"
                  size="small"
                  class="blank-input"
                  @input="handleInputChange"
                />
              </div>
            </div>
          </div>

          <!-- 答案展示区域 -->
          <div v-if="haveAnswer" class="answer-section">
            <!-- 答案信息区 -->
            <div class="answer-info">
              <!-- 标准答案 -->
              <div class="info-row standard-answer-row">
                <span class="label">标准答案</span>
                <div class="answers-list">
                  <el-input
                    v-for="(answer, index) in correctAnswers"
                    :key="'correct-'+index"
                    :value="correctAnswers.length > 1 ? '第' + (index + 1) + '空: ' + answer : answer"
                    readonly
                    size="small"
                    class="answer-input standard-answer"
                  />
                </div>
              </div>
              
              <!-- 您的答案 -->
              <div class="info-row user-answer-row">
                <span class="label">您的答案</span>
                <div class="answers-list">
                  <el-input
                    v-for="(answer, index) in userAnswers"
                    :key="'user-'+index"
                    :value="userAnswers.length > 1 ? '第' + (index + 1) + '空: ' + (answer || '未填写') : (answer || '未填写')"
                    readonly
                    size="small"
                    class="answer-input user-answer"
                  />
                </div>
              </div>
              
              <!-- 结果 + 难度 -->
              <div class="info-row two-col">
                <div class="info-item">
                  <span class="label">结果</span>
                  <el-tag size="small" v-if="questionBody.answerInfo.doRight" type="success" effect="light">
                    <i class="el-icon-check"></i> 正确
                  </el-tag>
                  <el-tag size="small" v-else type="danger" effect="light">
                    <i class="el-icon-close"></i> 错误
                  </el-tag>
                </div>
                <div class="info-item">
                  <span class="label">难度</span>
                  <el-rate v-model="questionBody.difficult" disabled class="difficulty-rate"></el-rate>
                </div>
              </div>
              
              <!-- 得分 + 得分率 -->
              <div class="info-row two-col">
                <div class="info-item">
                  <span class="label">得分</span>
                  <span class="value">
                    <span class="score-current">{{ questionBody.answerInfo.score }}</span>
                    <span class="score-divider">/</span>
                    <span class="score-total">{{ questionBody.score }}</span>
                  </span>
                </div>
                <div class="info-item">
                  <span class="label">得分率</span>
                  <span class="value score-rate" :class="{'rate-success': questionBody.answerInfo.score > 0}">
                    {{ parseInt(questionBody.answerInfo.score / questionBody.score * 100) }}%
                  </span>
                </div>
              </div>
            </div>
            
            <!-- 解析区 -->
            <div class="info-row analysis-row">
              <span class="label">解析</span>
              <div class="analysis-content" v-html="processedAnalyze"></div>
            </div>
          </div>
        </div>
      </el-card>
    </div>
    <amendDialog v-if="!isWrongBookPage" :amendDialogShow="amendDialogShow"
                 :questionId="this.questionBody.id"
                 @closeAmendDialog="closeAmendDialog">
    </amendDialog>

    <analysisDialog v-if="!isWrongBookPage" :analysisDialogShow="analysisDialogShow" :questionId="this.questionBody.id"
                    @closeAnalysisDialog="closeAnalysisDialog"></analysisDialog>
  </div>
</template>

<script>
import amendDialog from "@/components/amendDialog.vue"
import analysisDialog from "@/components/analysisDialog.vue"

export default {
  components: {
    analysisDialog,
    amendDialog
  },
  props: {
    subjectId: {
      type: Number,
      default: 1
    },
    isDis: {
      type: Boolean,
      default: false
    },
    questionBody: {
      type: Object,
      default: () => ({})
    },
    haveAnswer: {
      type: Boolean,
      default: false
    },
    chooseItem: {
      type: String,
      default: ""
    }
  },
  mounted() {
    this.initBlankInputs()
    if (this.haveAnswer && this.questionBody.answerInfo) {
      this.userAnswers = this.parseAnswers(this.questionBody.answerInfo.content)
    }
  },
  watch: {
    blankInputs: {
      handler: function (newInputs) {
        if (this.haveAnswer) return

        const hasContent = newInputs.some(input => input && input.trim())
        if (hasContent) {
          this.$emit("changed", {
            id: this.subjectId,
            name: newInputs.join('|'), // 用|分隔多个答案
            questionId: this.questionBody.id,
            content: newInputs.join('|'),
            contentArray: newInputs,
            itemOrder: this.subjectId
          })
        } else {
          this.$emit("unchanged", {
            id: this.subjectId,
            name: ''
          })
        }
      },
      deep: true
    }
  },
  data() {
    return {
      blankInputs: [], // 存储用户输入的答案数组
      userAnswers: [], // 解析后的用户答案
      correctAnswers: [], // 解析后的正确答案
      amendDialogShow: false,
      analysisDialogShow: false
    }
  },
  methods: {
    // 初始化填空输入框
    initBlankInputs() {
      const enterNum = this.questionBody.enterNum || 1
      this.blankInputs = new Array(enterNum).fill('')

      // 解析正确答案
      if (this.questionBody.correct) {
        this.correctAnswers = this.parseAnswers(this.questionBody.correct)
      }
    },

    // 解析答案字符串为数组
    parseAnswers(answerStr) {
      if (!answerStr) return []

      // 支持多种分隔符：| , ; \n
      return answerStr.split(/[\|,;\n]/).map(ans => ans.trim()).filter(ans => ans)
    },

    // 处理输入变化
    handleInputChange() {
      // 触发watch
    },

    openAmendDialog() {
      // 如果在wrongBook页面，通过事件通知父组件
      if (this.isWrongBookPage) {
        this.$emit('openAmendDialog');
      } else {
        this.amendDialogShow = true;
      }
    },
    closeAmendDialog() {
      this.amendDialogShow = false;
    },
    openAnalysisDialog() {
      // 如果在wrongBook页面，通过事件通知父组件
      if (this.isWrongBookPage) {
        this.$emit('openAnalysisDialog');
      } else {
        this.analysisDialogShow = true;
      }
    },
    closeAnalysisDialog() {
      this.analysisDialogShow = false;
    },
    collectQuestion() {
      this.$message({
        type: 'success',
        message: '收藏成功！'
      });
    }
  },
  computed: {
    // 处理题目标题中的图片 URL
    processedTitle() {
      return this.$processImages(this.questionBody.title);
    },
    // 处理解析中的图片 URL
    processedAnalyze() {
      return this.$processImages(this.questionBody.analyze);
    },
    // 判断是否为紧凑模式（试卷页面）
    isCompactMode() {
      return this.$route.path === '/testPaperDetails';
    },
    // 判断是否在wrongBook页面
    isWrongBookPage() {
      return this.$route.path === '/wrongBook';
    },
    // 获取当前菜单路径，这里假设从路由中获取
    currentPath() {
      return this.$route.path; // 假设路由路径为/a或/b
    },
    // 根据路径计算margin样式
    getMarginStyles() {
      if (this.currentPath === '/testPaperDetails') {
        return {
          'margin-bottom': '-20px',
          'margin-top': '-10px'
        };
      }
      // 路径为/b或其他时返回空对象
      return {};
    }
  }
}
</script>

<style lang="scss" scoped>

/* 紧凑模式下减少卡片左右间距（试卷页面） */
.compact-mode ::v-deep .el-card__header {
  padding-left: 0px;
  padding-right: 10px;
  border-bottom: none;
}

.compact-mode ::v-deep .el-card__body {
  padding-left: 0px;
  padding-right: 10px;
}

:deep(.editor-content-view pre) {
  word-wrap: normal;
  font-family: Consolas, Monaco, Andale Mono, Ubuntu Mono, monospace;
  background-color: #F5F2F0;
  border-radius: 5px;
  padding: 10px 10px;
  margin-top: 5px;
  overflow-x: auto;
  font-size: 16px;
  line-height: 1.5;
  min-width: 750px;
  tab-size: 4;
}

:deep(.editor-content-view pre) {
  /*background-color: #eee;*/
  /*padding: 5px;*/
  /*border-radius: 3px;*/
}

/* 确保sub和sup标签被正确显示 */
::v-deep sub {
  vertical-align: sub;
  font-size: smaller;
}

::v-deep sup {
  vertical-align: super;
  font-size: smaller;
}

.subjectName {
  display: flex;
  align-items: flex-start;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  line-height: 1.6;

  .question-number {
    font-size: 18px;
    font-weight: 600;
    color: #303133;
    margin-right: 6px;
    flex-shrink: 0;
  }

  .question-title-content {
    font-size: 18px;
    color: #303133;
    line-height: 1.6;
    letter-spacing: 0.3px;
  }

  p {
    font-size: 18px;
  }
}

.blank-content-area {
  margin-top: -12px;
  margin-bottom: 12px;
}

.blank-inputs {
  margin-top: 20px;

  .blank-input-group {
    display: flex;
    flex-direction: column;
    gap: 10px;

    .blank-label {
      font-size: 16px;
      font-weight: 500;
      color: #333;
    }

    .inputs-container {
      display: flex;
      flex-wrap: wrap;
      gap: 15px;

      .blank-input {
        min-width: 120px;
        max-width: 300px;
        flex: 1;

        // 添加内边距避免文字顶格显示
        :deep(input) {
          padding: 0 5px;
        }
      }
    }
  }
}

/* 答案区域样式 */
.answer-section {
  margin: 20px 0 10px 0;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #e8e8e8;
}

.answer-info {
  padding: 12px 20px;
  background: #fafafa;
}

.info-row {
  display: flex;
  align-items: flex-start;
  padding: 10px 0;
  border-bottom: 1px dashed #e8e8e8;

  &:last-child {
    border-bottom: none;
  }

  &.standard-answer-row,
  &.user-answer-row {
    .label {
      min-width: 70px;
      padding-top: 6px;
    }
    
    .answers-list {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
    }
  }

  &.two-col {
    display: flex;
    align-items: center;
    gap: 60px;
  }
  
  &.analysis-row {
    align-items: flex-start;
    
    .label {
      min-width: 50px;
      padding-top: 2px;
    }
  }
}

.info-item {
  display: flex;
  align-items: center;
  min-width: 200px;
}

.label {
  font-size: 14px;
  color: #909399;
  margin-right: 12px;
  min-width: 50px;
}

.value {
  font-size: 14px;
  color: #333;
}

.score-current {
  font-weight: 600;
  color: #F56C6C;
  font-size: 16px;
}

.score-divider {
  margin: 0 4px;
  color: #c0c4cc;
}

.score-total {
  color: #909399;
}

.score-rate {
  font-weight: 600;
  color: #F56C6C;
  font-size: 16px;

  &.rate-success {
    color: #67C23A;
  }
}

.difficulty-rate {
  ::v-deep .el-rate__icon {
    font-size: 16px;
  }
}

/* 解析内容 */
.analysis-content {
  flex: 1;
  font-size: 14px;
  line-height: 1.8;
  color: #606266;

  &:empty::before {
    content: '暂无解析';
    color: #c0c4cc;
  }
}

.answer-input {
  width: auto;
  min-width: 120px;
  max-width: 300px;
  
  :deep(.el-input__inner) {
    padding: 0 10px;
    background-color: #f5f7fa;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    color: #606266;
    text-align: left;
  }
}

.standard-answer {
  :deep(.el-input__inner) {
    background-color: #f0f9eb;
    border-color: #e1f3d8;
    color: #67c23a;
    font-weight: bold;
  }
}

.user-answer {
  :deep(.el-input__inner) {
    background-color: #fdf6ec;
    border-color: #faecd8;
    color: #e6a23c;
  }
}

.content {
  margin-top: 20px;
  display: flex;

  span {
    color: #000;
    line-height: 20px;
  }

  .answer-item {
    display: inline-block;
    margin-right: 15px;
    padding: 2px 8px;
    background: #f0f0f0;
    border-radius: 3px;
    font-size: 14px;
  }
}

</style>
